export function registerAutoFocus(): Disposable {
  document.addEventListener("spa.navigate", onNavigate);

  return {
    [Symbol.dispose]: () => {
      document.removeEventListener("spa.navigate", onNavigate);
    },
  };
}

function onNavigate() {
  const focus = document.querySelector("[autofocus]");
  if (!focus) {
    return;
  }

  if (focus instanceof HTMLElement) {
    focus.focus({ focusVisible: true });
  }
}
